import script from "./BaseSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./BaseSkeleton.vue?vue&type=style&index=0&id=76765abe&lang=scss"

const __exports__ = script;

export default __exports__